import { Component, OnInit } from "@angular/core";
import { trigger, transition, animate, style } from "@angular/animations";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { FormsModule } from "@angular/forms";
@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styleUrls: ["./update-password.component.css"],
})
export class UpdatePasswordComponent {
  model = {
    username: "",
    tempPass: "",
    newPass: "",
    newConfirmPass: "",
  };
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  type: string;
  message: string;
  alerts: any[] = [];
  menus: any[] = [];
  NewPass;
  NewConfirmPass;
  submenu: any[] = [];
  internalLinks: any[] = [];
  users: any[] = [];
  cookieValue = "UNKNOWN";
  resetPasswordForm;
  emailVal;
  userName;
  visible: boolean = true;
  visible1: boolean = false;
  submitResetPass: boolean = true;
  TempPass;
  getEmailVal;
  confirmMailDisable = true;
  showChangePassword: boolean = false;
  PresentYearVal;
  newPassFocused: boolean = false;
  passwordPtn: string =
    "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[#!@\\$%\\^&\\*\\-\\?]).{8,12}$";
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    sessionStorage.setItem("invUIToken", "");
    sessionStorage.setItem("user", "");
    let presentDate = new Date();
    this.PresentYearVal = presentDate.getFullYear();
  }

  getLoginApi(loginJson): Observable<any> {
    let uname = loginJson.username;
    let pswd = loginJson.password;
    const url = this.urlAuthentication.itocUrl + this.apiUrl.loginUrl;
    var authorizationBasic = window.btoa(uname + ":" + pswd);
    const httpHeaders = new HttpHeaders()
      .set("Accept", "application/json")
      .set("Authorization", "Basic " + authorizationBasic)
      .set("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
    return this.http.get(url, { headers: httpHeaders, observe: "response" });
  }
  close(alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  addSubMenus(name) {
    this.submenu.push(name);
    return this.submenu;
  }

  LoginButton() {
    const link = "#/login";
    window.open(link, "_self", "");
  }
  NextEmail(userNam) {
    this.userName = userNam;
    let userName = { loginID: this.userName };
    this.http
      .post(this.urlAuthentication.jwtUrl + this.apiUrl.forgotPass, userName)
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res);
          const generateProcess = JSON.parse(getImgResp);
          let response = generateProcess.response.code;
          if (generateProcess.response.Data.includes("failed")) {
            this.alerts = [];
            this.alerts.push({
              type: "success",
              message: response,
            });
            this.visible = false;
            this.showChangePassword = true;
          } else {
            this.alerts = [];
            this.alerts.push({
              type: "danger",
              message: response,
            });
            this.visible = true;
            this.showChangePassword = false;
          }
        },
        (error) => {
          console.error(error);

          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: "Please Enter Valid User Name",
          });
          this.spinner.hide();
        }
      );
  }

  changeInputEmail(value) {
    this.confirmMailDisable;
    if (value == this.getEmailVal) {
      this.emailVal = value;
      this.confirmMailDisable = false;
      this.showChangePassword = false;
    } else {
      this.confirmMailDisable = true;
      this.showChangePassword = false;
    }
  }

  confirmEmail() {
    const loginJson = {
      UserName: this.userName,
      EmailId: this.emailVal,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.forgetPassUrl,
        loginJson
      )
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res);
          const generateProcess = JSON.parse(getImgResp);
          this.showChangePassword = true;
          this.visible = false;
          this.visible1 = false;
          this.alerts = [];
          this.spinner.hide();
          this.alerts.push({
            type: "success",
            message: generateProcess,
          });
        },
        (error) => {
          console.error(error);

          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: "Log In failed, Please try again!!!",
          });
          this.spinner.hide();
        }
      );
  }
  submitResetPassword(userName, tempPass, newPass, CmfnewPass) {
    if (!userName) {
      this.alerts = [{ type: "danger", message: "Please Enter User Name" }];
    } else if (!tempPass) {
      this.alerts = [
        { type: "danger", message: "Please Enter Temporary Password" },
      ];
    } else if (newPass !== CmfnewPass) {
      this.alerts = [{ type: "danger", message: "Password doesn't match" }];
    } else {
      let PostJson = {
        loginID: userName,
        tempPwd: tempPass,
        newPwd: newPass,
      };
      this.http
        .post(
          this.urlAuthentication.jwtUrl + this.apiUrl.changePasswordUrl,
          PostJson
        )
        .subscribe((res) => {
          const generateProcess = JSON.parse(JSON.stringify(res));
          if (!generateProcess.response.Data.includes("Incorrect")) {
            this.alerts = [
              { type: "success", message: generateProcess.response.Data },
            ];
            setTimeout(() => {
              this.alerts = [];
              window.open("#/login", "_self", "");
            }, 5000);
          } else {
            this.alerts = [
              { type: "danger", message: generateProcess.response.Data },
            ];
          }
        });
    }
  }
}
